Vue.component('ack-product-collateral-icons', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-product-collateral-icons',
    mounted() {
      console.log('ack-product-collateral-icons mounted')


    },
    props:{
      iconItems: { // :product-info
        type: Array,
        required: true
      }
    },
    computed: {
      ...Vuex.mapGetters('localization', ['isUS_CA']), //isStoreAvailable
      ...Vuex.mapGetters('shop', ['isStoreAvailable']),
      
      itemsWithAvailability(){
        return this.iconItems.map((m) => {
          let item = m
  
            if(item.onlyIfStoreAvailable == true){
              if(this.isStoreAvailable){
                item.isAvailable = true
              } else {
                item.isAvailable = false
              }
            } else {
              item.isAvailable = true
            }
  
          return item
        })
      },
    },
    data() {
      return {

      }
    },
    methods: {
      //...Vuex.mapActions(['sayHi', 'someAction']),
      //...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns'])

    },
    beforeDestroy() {

    },
    watch: {
      isMobile: {
        handler() {


        },
        deep: false
      }
    }
  })